import styled, { css } from "styled-components";

const LoginPage = styled.div`
  text-align: center;
  flex-direction: column;
  display: flex;
  gap: 10px;
  align-items: center;
  height: 100%;
  justify-content: center;
`;

const LoginContainer = styled.div`
  ${({ theme: { colors } }) => {
    return css`
      padding: 20px;
      border: 1px solid ${colors.brandBlue};

      border-radius: 10px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      background-color: ${colors.lighterGray};
      align-items: center;
      gap: 10px;

      & > h1 {
        font-size: 30px;
        margin: 0;
      }

      & > p {
        font-size: 16px;
        margin: 0;
      }
    `;
  }}
`;

export { LoginPage, LoginContainer };
